import { SUPPORT_URL } from "../constants/support";
import { RootMenuItem } from "../types/nav";
import {
  CustomerDetails,
  launchForethoughtSupport,
  launchForethoughtBugReport,
} from "../helpers/forethoughtHelper";

export const legacySupportMenuStructure = {
  screenSetting: null,
  title: "Support",
  iconClass: "fas fa-user-headset",
  menuStructure: null,
  subMenu: null,
};

export const getSupportMenuStructure = (
  customerDetails: CustomerDetails
): RootMenuItem => ({
  title: "Support",
  target: "/Support",
  iconClass: "fas fa-question-circle",
  menuStructure: undefined,
  subMenu: {
    title: "Support",
    links: [
      {
        title: "Help Files",
        href: SUPPORT_URL,
        external: true,
      },
      {
        title: "Helpbot",
        href: null,
        clickHandler: () => launchForethoughtSupport(customerDetails),
      },
      {
        title: "Report Bug",
        href: null,
        clickHandler: () => launchForethoughtBugReport(customerDetails),
      },
    ],
  },
});
